/** @format */

import { ChartDetail, DonutChart } from "_components/atoms"
import { DSDonutContainer, DSContainer, DSDetailsontainer } from "./DashboardStats.styled"
import { DashboardStatsProps } from "./DashboardStats.types"
import { colorPalette } from "_shared/styles/color"

/**
 * Dashboard statistics (molecule)
 *
 * @param props
 * @returns React Component
 */
const DashboardStats = (props: DashboardStatsProps) => {
	const { availableCount, notUsedCount, usedCount, isLoading } = props

	let donutValues: number[] = []
	if (availableCount > 0 || notUsedCount > 0 || usedCount > 0) {
		donutValues = [availableCount, notUsedCount, usedCount]
	}

	return (
		<DSContainer data-testid="dashboard-stats">
			<DSDonutContainer>
				<DonutChart values={donutValues} isLoading={isLoading}></DonutChart>
			</DSDonutContainer>
			<DSDetailsontainer>
				{isLoading ? (
					[1, 2, 3].map(i => <ChartDetail color="" value={null} isLoading text="" key={i} />)
				) : (
					<>
						{!!availableCount && (
							<ChartDetail
								color={colorPalette.saphir}
								value={availableCount}
								text={`disponible${availableCount > 1 ? "s" : ""}`}
								key={1}
							/>
						)}
						{!!notUsedCount && (
							<ChartDetail
								color={colorPalette.lightBlue}
								value={notUsedCount}
								text={`distribué${notUsedCount > 1 ? "s" : ""} et non utilisé${notUsedCount > 1 ? "s" : ""}`}
								key={2}
							/>
						)}
						{!!usedCount && (
							<ChartDetail
								color={colorPalette.lighterSaphir}
								value={usedCount}
								text={`utilisé${usedCount > 1 ? "s" : ""}`}
								key={3}
							/>
						)}
					</>
				)}
			</DSDetailsontainer>
		</DSContainer>
	)
}

export default DashboardStats
